import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const attorneyTransactionTypeMap: Record<AttorneyTransactionType, MapItem> = {
  purchase: { label: 'Purchase' },
  sale: { label: 'Sale' },
  refinancing: { label: 'Refinancing' },
  lease_agreement: { label: 'Lease Agreement' },
  title_search: { label: 'Title Search/Clearance' },
  other: { label: 'Other' },
}

// Schema that includes both the type and optional custom value
export const attorneyTransactionTypeSchema = z.enum(
  Object.keys(attorneyTransactionTypeMap) as [AttorneyTransactionType, ...AttorneyTransactionType[]],
)

export type AttorneyTransactionType = 'purchase' | 'sale' | 'refinancing' | 'lease_agreement' | 'title_search' | 'other'

export type AttorneyTransactionTypeWithCustom = z.infer<typeof attorneyTransactionTypeSchema>
